<template>
  <div>
    <div class="text-center">
      <ul class="type-tab wwf-radio-bttns">
        <li v-for="productdetail in productidsdetail">
          <label>
            <input
              type="radio"
              v-model="product"
              name="product"
              :value="productdetail"
              :id="'id-' +productdetail.productname"
              v-validate="'required'"
            />
            {{productdetail.productname}}
            <span class="wwf-radio"></span>
          </label>
        </li>
      </ul>
    </div>

    <ul class="widget-dollar-handles" v-if="product != null">
      <li v-for="dollarhandle in product.dollarhandles[product.donationtypes[0]]">
        <div class="inner">
          <div class="img">
            <span :style="'background-image: url('+dollarhandle.img+')'"></span>
          </div>
          <div class="desc">
            <h2>${{(dollarhandle.amount.indexOf('.00') >= 0) ? dollarhandle.amount.slice(0,-3) : dollarhandle.amount}}</h2>
            <h5>{{dollarhandle.text}}</h5>
          </div>
          <p
            v-on:click="redirect(product.urlPath,dollarhandle.amount,dollarhandle.amount)"
            class="donate-amount"
          >Donate ${{(dollarhandle.amount.indexOf('.00') >= 0) ? dollarhandle.amount.slice(0,-3) : dollarhandle.amount}}</p>
        </div>
      </li>
      <li>
        <div class="inner">
          <div class="img">
            <span class="dh-misc-img"></span>
          </div>
          <div class="desc">
            <div class="other-amount" :class="customamount ? 'has-other-content' : ''">
              <!-- <input type="tel" ref="customhandle" name="custom-handle" id="custom-handle" v-validate="{required: true, checkifvalid: true, regex: /^\d+(\.\d{1,2})?$/}" v-model="amount" :class="{'border-red': errors.has('custom-handle')}" placeholder="Choose an amount" data-vv-as="amount"> -->
              <input v-model="customamount" type="tel" />
              <div class="pencil">
                <i class="fas fa-pencil-alt"></i>
                <span></span>
              </div>
            </div>
            <h5>choose your own amount</h5>
          </div>
          <p
            v-on:click="redirect(product.urlPath,"custom",customamount)"
            class="donate-amount"
          >Donate ${{(customamount && customamount.indexOf('.00') >= 0) ? customamount.slice(0,-3) : customamount}}</p>
        </div>
      </li>
    </ul>
  </div>
</template>


<script>
export default {
  name: "DonateWidget",
  data() {
    return {
      //productids: ['one-off-donation','monthly-donation','net-free-north'],
      productidsdetail: null,
      product: null,
      customamount: ""
    };
  },
  props: {
    productIds: {
      // Attribute for the productID
      type: Array,
      required: true
    }
  },
  created: function() {
    // Get product data (+ packages details)
    this.$store.dispatch("getProductByIds", this.productIds).then(
      response => {
        console.log("getProductByIds", response);
        this.productidsdetail = response;
        this.product = this.productidsdetail[0];
      },
      error => {
        console.error("getProductByIds error", error);
      }
    );
  },
  methods: {
    redirect(urlPath, dollarhandle, amount) {
      window.open(
        urlPath +
          "?q=" +
          window.btoa("dollarhandle=" + dollarhandle + "&amount=" + amount),
        "_self"
      );
    }
  }
};
</script>


// WEBPACK FOOTER //
// DonateWidget.vue?45af3440